import styled, { css } from 'styled-components';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

import { CheckboxState } from '.';

export const CheckboxIconButton = styled.button<{
  $state: CheckboxState;
  $isDarkBackground: boolean;
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  background-color: ${({ $state }) =>
    [CheckboxState.INDETERMINATE, CheckboxState.CHECKED].includes($state) &&
    themeColors.backgroundPrimary};
  border: 2px solid transparent;
  border-radius: ${themeSpacing.radiusXSmall};

  transition: all 0.2s ease-in-out;

  ${({ $state }) =>
    $state === CheckboxState.UNCHECKED &&
    css`
      border-color: ${themeColors.borderStrong};
    `}

  &:hover {
    background-color: ${({ $state }) =>
      [CheckboxState.INDETERMINATE, CheckboxState.CHECKED].includes($state) &&
      themeColors.backgroundInverse};
    border-color: ${themeColors.borderFocus};
  }

  &:focus {
    border-color: ${themeColors.borderFocus};
    outline: 0;
  }

  ${({ $state, $isDarkBackground }) =>
    $isDarkBackground &&
    css`
      background-color: ${
        [CheckboxState.INDETERMINATE, CheckboxState.CHECKED].includes($state) &&
        themeColors.backgroundPrimaryInverse
      };
      border-color: ${$state === CheckboxState.UNCHECKED && themeColors.borderStrongInverse};

      &:hover {
        background-color: ${
          [CheckboxState.INDETERMINATE, CheckboxState.CHECKED].includes(
            $state,
          ) && themeColors.backgroundPrimaryInverseHover
        };
        border-color: ${themeColors.borderInverseFocus};
      }

      &:focus {
        border-color: ${themeColors.borderInverseFocus};
        outline: 0;
      }
    `}

  ${({ $state, $disabled }) =>
    $disabled &&
    css`
      background-color: ${
        [CheckboxState.INDETERMINATE, CheckboxState.CHECKED].includes($state) &&
        themeColors.backgroundDisabledSubtle
      };
      border-color: ${$state === CheckboxState.UNCHECKED && themeColors.borderStrongInverse};
    `}
`;
